import React from 'react';
import clsx from 'clsx';

/**
 * Centers page content on desktop. Mobile is full-width (unchanged layout).
 *
 *   reading — narrow editorial column for forms, profile, legal pages (≈640px)
 *   wide    — reserved for future 2-column layouts (≈1080px)
 */
interface PageContainerProps {
  width?: 'reading' | 'wide';
  className?: string;
  children: React.ReactNode;
}

export const PageContainer: React.FC<PageContainerProps> = ({
  width = 'reading',
  className,
  children,
}) => (
  <div
    className={clsx(
      'w-full mx-auto flex flex-col flex-1',
      width === 'reading' ? 'md:max-w-[640px]' : 'md:max-w-[1080px]',
      className
    )}
  >
    {children}
  </div>
);
